export enum EMessageRole {
  USER = "USER",
  AI = "AI",
}

export type TSession = {
  id: string;

  status: string;
  userId: string;
  name: string;

  createdAt: string;
  updatedAt: string;
};

export type TMessage = {
  id: string;

  sessionId: string;
  role: EMessageRole;
  content: any;

  createdAt: string;
  updatedAt: string;
};
